import { Box, Card, type SxProps } from '@mui/material';

import { ResultsPageTabContent as V0ResultsPageTabContent } from '../../containers/v0/cohort-builder-page-tabs/ResultsPageTabContent/ResultsPageTabContent';
import { TabEmptyState } from '../components/TabEmptyState/TabEmptyState';

// Left-aligned column layout matching the Definition tab (paddingX 6 = the
// 24px page gutter shared with the header/tabs) and the Results Figma spec
// (M4 visual audit): modules stack vertically with a 24px gap instead of the
// legacy centered wrap layout.
const GEN3_CONTENT_SX: SxProps = {
  flexDirection: 'column',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  paddingX: 6,
  paddingY: 3,
  gap: 6,
  maxWidth: 'none',
  height: 'auto',
};

// Empty state: an outlined card + centered TabEmptyState identical to the
// gen-3 SQL tab (same size and typography), sitting in the shared 24px/12px
// gutter — so "Cohort not processed" reads as the same surface as "No SQL".
const renderGen3EmptyState = ({
  id,
  title,
  message,
}: {
  id: string;
  title: string;
  message: string;
}) => (
  <Box sx={{ paddingX: 6, paddingY: 3 }}>
    <Card variant="outlined" sx={{ padding: 6, minWidth: 0 }} data-testid={id}>
      <TabEmptyState title={title} message={message} />
    </Card>
  </Box>
);

/**
 * Results tab body for the gen-3 cohort detail page.
 *
 * **Placeholder.** Currently mounts the legacy v0 Results content with a
 * gen-3 layout override so the modules align with the rest of the page
 * (M4 visual audit). Subsequent commits replace the v0 mount with
 * responsive AttritionCard / CharacteristicsCard / SubjectsCard siblings
 * owned by gen-3, each with TanStack-driven reads.
 *
 * TODO: cleanup with research_assistant_gen_3 ff (delete the v0 mount
 * once gen-3 cards land).
 */
export const ResultsTab = () => {
  return (
    <Box data-testid="cohort-detail-results-tab" sx={{ width: '100%', minHeight: 0 }}>
      <V0ResultsPageTabContent
        contentSx={GEN3_CONTENT_SX}
        renderEmptyState={renderGen3EmptyState}
      />
    </Box>
  );
};
